import React from "react";

const Footer = () => {
  return (
    <p className="footer-text">
      Built with{" "}
      <a href="https://react.dev/" className="chord-links" target="_blank" rel="noreferrer">
        React
      </a>{" "}
      and a local chord database. Some combinations may not have diagrams available.
    </p>
  );
};

export default Footer;
